import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api/donnees`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('finance_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const donneesApi = {
  getSources: () => api.get('/sources'),
  getApercu: (code) => api.get(`/apercu/${code}`),
  analyserVn: () => api.post('/analyses/vn', {}, { timeout: 300000 }),
  fgDimensions: () => api.get('/fg/dimensions'),
  fgFournisseurs: (params) => api.get('/fg/fournisseurs', { params }),
  fgFournisseur: (code, params) => api.get(`/fg/fournisseur/${code}`, { params }),
  getAnalyses: (type) => api.get('/analyses', { params: { type } }),
  getAnalyse: (id) => api.get(`/analyses/${id}`),
};

export default donneesApi;
